import { InternalAccessor } from '@billy/design-system'
import { useMemo } from 'react'

import { useBuildTransactionUrl } from '@features/transactions/hooks/useBuildTransactionUrl'
import { useTaxRates } from '@modules-deprecated/app/taxrates'

import { AuditTrailTableAccessor } from '../enums/AuditTrailTableAccessor'
import { AuditTrailItem } from '../types/AuditTrail'
import { AuditTrailTableRow } from '../types/AuditTrailTableRow'

interface UseTableDataParams {
  data: AuditTrailItem[]
}

export const useTableData = ({ data }: UseTableDataParams): AuditTrailTableRow[] => {
  const { getUrl } = useBuildTransactionUrl()
  const { taxRates } = useTaxRates()

  return useMemo(
    () =>
      data.map(
        ({
          abbreviation,
          amount,
          balance,
          date,
          description,
          externalId,
          id,
          isVoided,
          netAmount,
          rate,
          transaction,
          transactionId,
          type,
          voucher,
          isFooter,
        }) => {
          const url = !isFooter
            ? getUrl({
                externalId,
                originatorType: type,
                originatorId: id,
              })
            : undefined

          const taxRate = taxRates?.find((rate) => rate.abbreviation === abbreviation)
          const { name: taxName, description: taxDescription } = taxRate || {}

          return {
            id,
            [AuditTrailTableAccessor.Amount]: { amount, isVoided },
            [AuditTrailTableAccessor.Balance]: balance,
            [AuditTrailTableAccessor.Date]: date,
            [AuditTrailTableAccessor.Description]: { description, url },
            [AuditTrailTableAccessor.NetAmount]: netAmount,
            [AuditTrailTableAccessor.Rate]: { rate, name: taxName, description: taxDescription },
            [AuditTrailTableAccessor.Transaction]: { transaction, transactionId },
            [AuditTrailTableAccessor.Voucher]: voucher,
            [InternalAccessor.Disabled]: isVoided,
          }
        },
      ),
    [data, getUrl, taxRates],
  )
}
